import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';

export const styles = stylex.create({
  dropdownContainer: {
    position: 'relative',
    fontFamily: fonts.din2014Regular,
  },

  dropdownContainerDisabled: {
    cursor: 'not-allowed',
  },

  dropdownTriggerWrap: {
    position: 'relative',
  },

  dropdownTriggerWrapDisabled: {
    cursor: 'not-allowed',
  },

  label: {
    display: 'block',
    marginBottom: '2px',
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.secondaryText,
  },

  dropdownButton: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    gap: '8px',
    width: '256px',
    outline: 'none',
    color: colors.primaryText,
    backgroundColor: colors.primaryBackground,
    ':focus': {
      borderColor: colors.accentBorder,
    },
    ':focus-visible': {
      borderColor: colors.accentBorder,
    },
  },

  dropdownButtonSmall: {
    padding: '7px 12px',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  fullWidth: {
    width: '100%',
  },

  dropdownButtonTextPlaceholder: {
    color: colors.tertiaryText,
  },

  dropdownButtonIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  chevronIcon: {
    transition: 'transform 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  chevronIconOpen: {
    transform: 'rotate(180deg)',
  },

  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: '4px',
    border: `1px solid ${colors.ghostBorder}`,
    borderRadius: anatomy.borderRadiusS,
    backgroundColor: colors.primaryBackground,
    overflow: 'hidden',
    maxHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
  },

  searchInputWrap: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
  },

  searchIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: colors.tertiaryIcon,
  },

  searchInput: {
    flex: 1,
    minWidth: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
  },

  dropdownListScroll: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  dropdownListUl: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },

  dropdownItem: {
    display: 'flex',
  },
  dropdownItemButton: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    gap: '8px',
    textAlign: 'left',
    borderRadius: anatomy.borderRadiusXs,
    boxSizing: 'border-box',
    ':hover': {
      backgroundColor: colors.hoverBackground,
    },
    ':not(#__unused__) > svg': {
      marginLeft: 'auto',
    },
  },
  dropdownItemSelected: {
    backgroundColor: colors.hoverBackground,
  },

  dropdownItemSelectedText: {
    color: colors.accentText,
  },

  radioWrapper: {
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  dropdownButtonError: {
    borderColor: colors.errorBorder,
  },

  dropdownButtonDisabled: {
    backgroundColor: colors.ghostBackground,
    borderColor: colors.ghostBorder,
    color: colors.foregroundTertiary,
    pointerEvents: 'none',
  },

  labelDisabled: {
    color: colors.ghostText,
  },

  dropdownButtonTextDisabled: {
    color: colors.ghostText,
  },

  errorText: {
    marginTop: '4px',
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.errorText,
    fontFamily: fonts.din2014Regular,
  },

  errorTextFloating: {
    position: 'absolute',
    top: '100%',
    marginTop: '3px',
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: '12px',
    color: colors.errorText,
    zIndex: 1,
  },
});
